"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MON305_PARAMETER_OPTIONS = exports.MON305_PARAMETER_KEY = exports.MON305_IN_APP_TREATMENT_KEY = exports.MON138_PARAMETER_OPTIONS = exports.MON138_PARAMETER_KEY = exports.MON138_IN_APP_TREATMENT_KEY = exports.MON138_PUBLIC_TREATMENT_KEY = void 0;
var MON138_PUBLIC_TREATMENT_KEY = 'cbx-138p';
exports.MON138_PUBLIC_TREATMENT_KEY = MON138_PUBLIC_TREATMENT_KEY;
var MON138_IN_APP_TREATMENT_KEY = 'cbx-138';
exports.MON138_IN_APP_TREATMENT_KEY = MON138_IN_APP_TREATMENT_KEY;
var MON138_PARAMETER_KEY = 'variant';
exports.MON138_PARAMETER_KEY = MON138_PARAMETER_KEY;
var MON138_PARAMETER_OPTIONS = {
  CONTROL: 'control',
  ANCHOR: 'anchor',
  SHIFTED: 'shifted'
};
exports.MON138_PARAMETER_OPTIONS = MON138_PARAMETER_OPTIONS;
var MON305_IN_APP_TREATMENT_KEY = 'cbx-305';
exports.MON305_IN_APP_TREATMENT_KEY = MON305_IN_APP_TREATMENT_KEY;
var MON305_PARAMETER_KEY = 'purchase';
exports.MON305_PARAMETER_KEY = MON305_PARAMETER_KEY;
var MON305_PARAMETER_OPTIONS = {
  CONTROL: 'control',
  VARIANT: 'variant'
};
exports.MON305_PARAMETER_OPTIONS = MON305_PARAMETER_OPTIONS;